export default {"src":"/_next/static/media/logo.cbbdb05d.svg","height":73,"width":180,"blurWidth":0,"blurHeight":0};